// Werkruimtes heetten eerder projecten, op /projects. Bladwijzers en gedeelde
// links met dat pad komen op dezelfde plek uit.
export const legacyWorkspacePath = (pathname: string, search = "", hash = ""): string | null => {
  const match = pathname.match(/^\/projects(\/\d+)?\/?$/);
  if (!match) return null;
  return `/workspaces${match[1] ?? ""}${search}${hash}`;
};
